import { render } from "./PopupTitle.vue?vue&type=template&id=22804964&scoped=true"
import script from "./PopupTitle.vue?vue&type=script&lang=js"
export * from "./PopupTitle.vue?vue&type=script&lang=js"

import "./PopupTitle.vue?vue&type=style&index=0&id=22804964&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22804964"]])

export default __exports__